import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { billingClient } from '#pplx_generated/typespec/rest/billing/client.js';
export const createGovernmentSubscription = async ({ reason, }) => {
    try {
        const { data, error, response } = await billingClient.POST('/rest/billing/create-government-subscription', reason, {
            timeoutMs: 6000,
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
                details: {
                    reason,
                },
            });
        }
        return {
            status: data.status,
            error_code: data.error_code ?? undefined,
            message: data.message ?? undefined,
        };
    }
    catch {
        return undefined;
    }
};
//# sourceMappingURL=createGovernmentSubscription.js.map